import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaProgressBarComponent} from './la-progress-bar.component';
import {LaImageModule} from '../image/la-image.module';

@NgModule({
  imports: [
    CommonModule,
    LaImageModule
  ],
  declarations: [LaProgressBarComponent],
  exports: [LaProgressBarComponent]
})
export class LaProgressBarModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaProgressBarModule,
      providers: []
    };
  }
}
